/**
 * Experience Layer
 *
 * Emotional context for the signal-driven homepage.
 */

export {
  STEP_EMOTIONAL_CONTEXTS,
  TREATMENT_PHASE_CONTEXTS,
  getStepEmotionalContext,
  getTreatmentEmotionalContext,
} from "./emotionalContextContent";
export type { EnhancedEmotionalContext } from "./emotionalContextContent";

export { getContextualSubline } from "./contextualSubline";
